import dayjs from 'dayjs';

/** Workspace date format (Admin → Settings). Synced from settings by AppLayout. */
let dateFormat = 'YYYY-MM-DD';

export function setDateFormat(fmt: string | undefined | null) {
  if (fmt) dateFormat = fmt;
}
export const getDateFormat = () => dateFormat;

type DateInput = string | number | Date | null | undefined;

/** Calendar date in the workspace format, or an em dash when empty. */
export function fmtDate(v: DateInput): string {
  return v ? dayjs(v).format(dateFormat) : '—';
}

/** Date and time in the workspace format, or an em dash when empty. */
export function fmtDateTime(v: DateInput): string {
  return v ? dayjs(v).format(`${dateFormat} HH:mm`) : '—';
}

/** "1 contact", "3 contacts", "1,204 contacts". */
export function plural(n: number, one: string, many = `${one}s`): string {
  return `${n.toLocaleString()} ${n === 1 ? one : many}`;
}
